<template>
  <b-modal id="ModalPostcode" size="lg" ref="ModalPostcode" title="주소검색">

    <vue-daum-postcode class="" @complete="onComplete" style="height: 500px; overflow: scroll;"/>


    <b-form-group style="margin-top: 50px;" label-cols="2" horizontal label="기본주소">
      <b-input-group>
        <b-form-input readonly type="text" v-model="roadAddress"></b-form-input>
        &nbsp
        <b-form-input type="text" readonly v-model="zipCode"></b-form-input>
      </b-input-group>
    </b-form-group>

    <b-form-group label-cols="2" horizontal :label="$t('store.detail-address')">
      <b-input-group>
        <b-form-input placeholder="상세주소" type="text" v-model="detailAddress"></b-form-input>
      </b-input-group>
    </b-form-group>
    <template slot="modal-footer">
      <b-button variant="primary" @click="confirm" class="mr-1">저장</b-button>
      <b-button variant="secondary" @click="hideModal">닫기</b-button>
    </template>


  </b-modal>
</template>

<script>
export default {
  name: "ModalPostcode",
  props: [],
  data() {
    return {
      roadAddress: null,
      jibunAddress: null,
      zipCode: null,
      detailAddress: null,
      engAddress: null,
      longitude: null,
      latitude: null,
      event: null,
      city: null,
      region: null,
    }
  },

  methods: {
    open() {
      this.$refs['ModalPostcode'].show()
    },
    onComplete($event) {
      // console.log($event)
      this.event = $event
      const post_data = this.event
      this.roadAddress = post_data.address
      this.jibunAddress = post_data.jibunAddress === "" ? post_data.autoJibunAddress : post_data.jibunAddress
      this.engAddress = post_data.roadAddressEnglish
      this.zipCode = post_data.zonecode
      this.region = post_data.sido
      this.city = post_data.sigungu

      this.getDetailDocuments()
    },

    confirm() {
      if(this.longitude == null || this.latitude == null) {
        alert("주소를 선택해주세요.")
        return
      }

      if(this.roadAddress == null || this.jibunAddress == null) {
        alert("주소를 선택해주세요.")
        return
      }

      if(this.detailAddress == null) {
        alert("상세주소를 입력해주세요.")
        return
      }

      const data = {
        roadAddress: this.roadAddress ,
        jibunAddress: this.jibunAddress ,
        engAddress: this.engAddress  ,
        detailAddress: this.detailAddress,
        zipCode: this.zipCode,
        longitude: this.longitude,
        latitude: this.latitude,
        city: this.city,
        region: this.region,
      }
      // console.log(data)
      this.$emit('confirm', {data: data})
      this.$refs['ModalPostcode'].hide()

    },

    //카카오 지도 검색
    getDetailDocuments() {
      const reqURL = 'https://dapi.kakao.com/v2/local/search/address.json';
      const params = {
        "query": this.roadAddress
      }
      this.$http.get(reqURL, {
        params: params,
        headers: {'Authorization': `KakaoAK 9ce1db9ad0028e118275de5a6d205767`}
      }).then(res => {
        this.latitude = res.data.documents[0].y
        this.longitude = res.data.documents[0].x

      }).catch(err => {
      })
    },

    hideModal() {
      this.roadAddress = null
      this.zipCode = null
      this.detailAddress = null
      this.$refs['ModalPostcode'].hide()
    }

  },

  mounted() {
  }

}
</script>

<style scoped>
</style>
